var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomesticI(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20ZM38 20C38 29.9411 29.9411 38 20 38C10.0589 38 2 29.9411 2 20C2 10.0589 10.0589 2 20 2C29.9411 2 38 10.0589 38 20ZM14.071 14.8284L14.7782 15.5355L10.5355 19.7782L9.8284 19.0711L14.071 14.8284ZM14.071 12L15.4853 13.4142L16.1924 14.1213L17.6066 15.5355L16.1924 16.9497L11.9497 21.1924L10.5355 22.6066L9.1213 21.1924L8.41419 20.4853L6.99998 19.0711L8.41419 17.6569L12.6568 13.4142L14.071 12ZM24.8284 15.5355L25.5355 14.8284L29.7782 19.0711L29.0711 19.7782L24.8284 15.5355ZM24.1213 13.4142L25.5355 12L26.9497 13.4142L31.1924 17.6569L32.6066 19.0711L31.1924 20.4853L30.4853 21.1924L29.0711 22.6066L27.6568 21.1924L23.4142 16.9497L22 15.5355L23.4142 14.1213L24.1213 13.4142ZM20.5 31V25H19.5V31H20.5ZM22.5 23H20.5H19.5H17.5V25L17.5 31V33H19.5H20.5H22.5V31V25V23Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomesticI);
export default __webpack_public_path__ + "static/media/DOMESTIC_I.9cd3cc05c75661092d7e07e3931af6ab.svg";
export { ForwardRef as ReactComponent };